module.exports = __webpack_public_path__ + "svg/no-status.svg?2c0cc05688634a4641dc96faa9f4099c";